import React, { useEffect, useState, useRef, useCallback } from "react"
import styled from "styled-components"

import Assist from "@components/Assist"
import Bio from "@components/Bio"
// import Search from "@components/search/default"
import TOC from "@components/TOC"


const Wrapper = styled.aside`
  margin: 0 40px 0 0;
  @media screen and (max-width: 950px) {
    display: block;
    width: auto;
    max-width: 730px;
    min-width: 0;
    margin: 0 auto 40px;
  }
`

const TOCWrapper = styled.div`
  @media screen and (max-width: 950px) {
    display: none;
  }
`

// const searchIndices = [{ name: `Pages`, title: `Pages` }]

const FixedWidgetInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: 950px) {
    display: none;
  }
`

const FixedWidget = () => {
  const isRunning = useRef(false)
  const [height, setHeight] = useState(typeof window !== "undefined" ? window.innerHeight : 100)

  useEffect(() => {
    document.addEventListener("resize", handleWindowHeight, { passive: true })
    return () => {
       document.removeEventListener("resize", handleWindowHeight, { passive: true })
    }
  }, [])

  const handleWindowHeight = useCallback(() => {
    if (!isRunning) return
    isRunning.current = true
    setHeight(window.innerHeight)
  }, [])

  return (
    <div style={{ position: "sticky", top: "40px" }}>
      <FixedWidgetInner style={{ height: `${height - 80}px`}}>
        <div style={{marginBottom: "40px"}}>
          <TOCWrapper style={{ width: "290px"}}>
            <TOC />
          </TOCWrapper>
        </div>
        <div id="assist" style={{ display: "relative" }}>
          <Assist />
        </div>
      </FixedWidgetInner>
    </div>
  )
}

const Sidebar = ({ af }) => {
  return (
    <Wrapper>
      {/* <Search
        indices={searchIndices}
      /> */}
      <Bio />
      <FixedWidget />
    </Wrapper>
  )
}

export default Sidebar